import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const AppPaidUsersReport = () => {
 const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData();
    }, [startDate, endDate]);



                                                                                  
             useEffect(() => {
                document.title = 'App Paid Users Report - Calendar Services';
            
                // Initialize the date range picker
                $("#kt_daterangepicker_4").daterangepicker(
                  {
                    startDate: moment(),
                    endDate: moment(),
                    ranges: {
                      Today: [moment(), moment()],
                      Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                      "Last 7 Days": [moment().subtract(6, "days"), moment()],
                      "Last 30 Days": [moment().subtract(29, "days"), moment()],
                      "This Month": [moment().startOf("month"), moment().endOf("month")],
                      "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
                    },
                  },
                  (start, end) => {
                    setStartDate(start.format("YYYY-MM-DD"));
                    setEndDate(end.format("YYYY-MM-DD"));
                    $("#kt_daterangepicker_4").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
                  }
                );
            
                // Set initial display value
                $("#kt_daterangepicker_4").html(
                  `${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`
                );
              }, []);
    



    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post("http://localhost:3036/app_paid_users", {
              // const response = await axios.post(`${API_BASE_URL}/app_paid_users`, {

                startDate,
                endDate,
            });
            setData(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { name: "SlNo", selector: (row, index) => index + 1, sortable: true },
        { name: "Name", selector: (row) => row.name, sortable: true },
        { name: "Mobile No", selector: (row) => row.mobileno, sortable: true },
        // { name: "Type", selector: (row) => row.type, sortable: true },
        // { name: "Invoice No", selector: (row) => row.inv_no, sortable: true },
        { name: "C Date", selector: (row) => row.cdate, sortable: true },
        // { name: "Status", selector: (row) => row.TXN_STATUS, sortable: true },
        { name: "Total Amount", selector: (row) => row.total_amount, sortable: true },
        { name: "Paid Method", selector: (row) => row.user, sortable: true },
        // { name: "Total Paid Amount", selector: (row) => row.TXN_AMOUNT, sortable: true },
        // { name: "Reg Date", selector: (row) => row.adddate, sortable: true },
    ];

    return (
        <div className="max-w-6xl mx-auto mt-8 bg-white">
            <h2 className="text-2xl font-bold mb-6 text-center">App Paid Users Report</h2>
             <div className="flex justify-center items-center gap-2 mb-6">
                                                                    <div className="mb-3">
                                                                                                    <div className="text-center mb-6 flex items-center space-x-2 justify-center">
                                                                                                      <div id="kt_daterangepicker_4" className="bg-white border px-4 py-2 inline-block rounded cursor-pointer">
                                                                                                        {`${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`}
                                                                                                      </div>
                                                                                        
                                                                                                      <svg
                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                        className="h-5 w-5 text-gray-500"
                                                                                                        fill="none"
                                                                                                        viewBox="0 0 24 24"
                                                                                                        stroke="currentColor"
                                                                                                      >
                                                                                                        <path
                                                                                                          strokeLinecap="round"
                                                                                                          strokeLinejoin="round"
                                                                                                          strokeWidth={2}
                                                                                                          d="M8 7V3m8 4V3m-6 4h6m4 0a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h12z"
                                                                                                        />
                                                                                                      </svg>
                                                                                                    </div>
                                                                                                  </div>
                                                                                                  </div>
                                                                                                  
            {loading ? (
                <p className="text-center mt-4">Loading...</p>
            ) : (
                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    highlightOnHover
                    className="mt-6"
                />
            )}
        </div>
    );
};

export default AppPaidUsersReport;